module.exports = __webpack_public_path__ + "static/img/9997a68c.svg";